module.exports = require('./helpers/bundle-url').getBundleURL('gK5mg') + "back-black.243b453b.svg";